<template id="map-template">
  <div class="map-root select-none">
    <div ref="map-onemap" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="map-right">
      <div>
        <ComponentPoiSearch :center="center" @searchPoi="search"></ComponentPoiSearch>
      </div>
    </div>
    <div @click="goCenter" class="map-location">景区位置</div>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMaterialStorageVisiable"
      :modal="true"
    >
      <MaterialWarehouseinfo v-bind:query="materialQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isRescueTeamVisiable"
    >
      <ResourcesTeaminfo v-bind:query="rescueTeamQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isTranresourcesmanageVisiable"
      :modal="true"
    >
      <Tranresourcesinfo v-bind:query="tranresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isSheltermanageVisiable"
      :modal="true"
    >
      <Shelterinfo v-bind:query="sheltermanageQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isCommunicationresourcesVisiable"
      :modal="true"
    >
      <Communicationresourcesinfo v-bind:query="communicationresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMedicalResourcesVisiable"
      :modal="true"
    >
      <Medicalresourcesinfo v-bind:query="medicalResourcesQuery" />
    </el-dialog>

    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMateriallistVisiable"
      :modal="true"
    >
      <Materiallist v-bind:query="materiallistQuery" :WarehouseId="materiallistQuery.warehouseId"/>
    </el-dialog>
  </div>
</template>

<script>
import ComponentTest from "./PoiSearch.vue";
import MaterialWarehouseinfo from "../Material/MaterialWarehouseinfo";
import ResourcesTeaminfo from "../Resources/ResourcesTeaminfo";
import Tranresourcesinfo from "../Resources/Tranresourcesinfo";
import Shelterinfo from "../Resources/Shelterinfo";
import Communicationresourcesinfo from "../Resources/Communicationresourcesinfo";
import Medicalresourcesinfo from "../Resources/Medicalresourcesinfo";

import Materiallist from "../Material/Materiallist";

export default {
  name: "ZjEmergencyOneMap",
  componentName: "ZjEmergencyOneMap",
  components: {
    ComponentPoiSearch: ComponentTest,
    MaterialWarehouseinfo: MaterialWarehouseinfo,
    ResourcesTeaminfo: ResourcesTeaminfo,
    Tranresourcesinfo: Tranresourcesinfo,
    Shelterinfo: Shelterinfo,
    Communicationresourcesinfo: Communicationresourcesinfo,
    Medicalresourcesinfo: Medicalresourcesinfo,
    Materiallist: Materiallist
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    }
  },
  data() {
    return {
      toUrl: "/plugin/emergency/ui/onemap",
      loadingText: "加载中...",
      mapInstance: null,
      dialogVisible: false,

      isMaterialStorageVisiable: false,
      materialQuery: {
        type: "search",
        id: "",
        category: ""
      },
      isRescueTeamVisiable: false,
      rescueTeamQuery: {
        type: "search",
        id: "",
        category: ""
      },
      isTranresourcesmanageVisiable: false,
      tranresourcesQuery: {
        type: "search",
        id: "",
        category: ""
      },
      isSheltermanageVisiable: false,
      sheltermanageQuery: {
        type: "search",
        id: "",
        category: ""
      },
      isCommunicationresourcesVisiable: false,
      communicationresourcesQuery: {
        type: "search",
        id: "",
        category: ""
      },
      isMedicalResourcesVisiable: false,
      medicalResourcesQuery: {
        type: "search",
        id: "",
        category: ""
      },

      isMateriallistVisiable: false,
      materiallistQuery: {
        type: "search",
        id: "",
        category: ""
      }
    };
  },
  methods: {
    goCenter: function() {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    addDom: function() {
      if (!this.mapInstance) return;

      // eslint-disable-next-line no-undef
      var $div = $("<div></div>");
      $div.append(this.getSvgContent());
      $div.css({
        width: "30rem",
        height: "30rem",
        "margin-left": "-15rem",
        "margin-top": "-15rem",
        position: "absolute"
      });

      var interval = setInterval(() => {
        if(this.mapInstance)
        {
          let layer = this.mapInstance.getLayerByName("DOM");
          if (layer && layer.addDom) {
            clearInterval(interval);
            layer.addDom(this.center[0], this.center[1], $div[0]);
          }
        }else{
          clearInterval(interval);
        }
      }, 1000);
    },
    addBlinkPoi: function() {
      if (this.mapInstance) {
        // eslint-disable-next-line no-undef
        var target = new BMap.Point(this.center[0], this.center[1]);
        //this.mapInstance.panTo(center);
        this.mapInstance.panTo(target);
        var pictureUrl = this.BASE_URL + "theme/default/img/animation10.gif";
        // eslint-disable-next-line no-undef
        var myIcon = new BMap.Icon(pictureUrl, new BMap.Size(1000, 1000));
        // eslint-disable-next-line no-undef
        var marker = new BMap.Marker(target, { icon: myIcon }); // 创建标注
        this.mapInstance.addOverlay(marker);
      }
    },
    getSvgContent: function() {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    //资源点查询方法，过滤地图点位
    search: function(text) {
      var map = this.mapInstance;
      var layers = map.getLayers();

      if (text) {
        // eslint-disable-next-line no-undef
        $(layers).each(function() {
          if (this.$className === "OverlayLayer") {
            this.filter(function(d) {
              var label = this.getLabel(d) || "";
              return label.indexOf(text) >= 0;
            });
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        $(layers).each(function() {
          if (this.$className === "OverlayLayer") {
            this.clearFilter();
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSearchResultPoiSelected: function(id) {
      console.log("onSearchResultPoiSelected:" + id);

      var overlay,
        layers = this.mapInstance.getLayers();

      for (let index = 0; index < layers.length; index++) {
        var ly = layers[index];
        if (ly.findOverlayById) {
          overlay = ly.findOverlayById(id);
          if (overlay && overlay.length > 0) {
            ly.onClick.apply(overlay[0], [{}]);
            break;
          }
        }
      }
    },
    showRecordDetail(params) {
      switch (params.category) {
        case "MaterialStorage":
          this.isMaterialStorageVisiable = true;
          this.materialQuery.id = params.id;
          break;
        case "RescueTeam":
          this.isRescueTeamVisiable = true;
          this.rescueTeamQuery.id = params.id;
          break;
        case "Tranresourcesmanage":
          this.isTranresourcesmanageVisiable = true;
          this.tranresourcesQuery.id = params.id;
          break;
        case "Sheltermanage":
          this.isSheltermanageVisiable = true;
          this.sheltermanageQuery.id = params.id;
          break;
        case "Communicationresources":
          this.isCommunicationresourcesVisiable = true;
          this.communicationresourcesQuery.id = params.id;
          break;
        case "MedicalResources":
          this.isMedicalResourcesVisiable = true;
          this.medicalResourcesQuery.id = params.id;
          break;
        default:
          console.error("未处理的物资类别 :" + params.category);
          break;
      }
    },
    showinventoryList(params) {
      
      this.materiallistQuery = params; 
      this.materiallistQuery.warehouseId = params.id; 
      console.log("hh"+this.materiallistQuery);
      console.log(this.materiallistQuery);
      this.isMateriallistVisiable = true;
    }
  },
  //  watch: {
  //   query: {
  //     // eslint-disable-next-line no-unused-vars
  //     handler: function (val, oldVal) {
  //       console.log('map watch');
  //       if(val != oldVal)
  //       // eslint-disable-next-line no-undef
  //      this.materiallistQuery.id = params.id;
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
  created() {
    
    console.debug("onemap created");
    this.$on("showRecordDetail", this.showRecordDetail);
    this.$on("showinventoryList", this.showinventoryList);
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-fullscreen-map");
    this.$on("poiselected", this.onSearchResultPoiSelected);
     console.log("hh22222"+this.materiallistQuery);
  },
  mounted() {
    // 创建地图，并通过样式让地图填满窗口
    let that = this;

    this.$nextTick(function() {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-onemap"]).zjumap({
        syscode: "ZJMap",
        key: "EmergencyOneMap",
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        mapConfigs: {
          //mapStyle: "styles/darknight.json",
          toggleTool: "tool/TreeToggleX",
          //tilesPath: "",
          //clickToShowLocation: false,
          //zoom:16,
          onMapCreated: function(e) {
            that.mapInstance = e.map;
            that.center = e.map.config.center;

            //that.addDom();
          },
          onGettingLayerData: function(e) {
            // eslint-disable-next-line no-undef
            e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
              Longitude: that.center[0],
              Latitude: that.center[1]
            });
          },
          //地图开关面板切换事件，切换右侧列表框的tab项
          onToogleSwitchClick: function(e) {
            that.broadcast(
              "componentPOISearchResult",
              "onMapToogleSwitchClick",
              e.type
            );
          },
          onLayerDetaiButtonClick: function(e) {
            console.log(e.data);
            var item = e.originEvent.currentTarget;
            // eslint-disable-next-line no-undef
            var id = e.data.id;
            // eslint-disable-next-line no-undef
            var category = $(item).data("category");
            var result = {
              id: id,
              type: "search",
              category: category
            };
            that.showRecordDetail(result);
          }
        }
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("onemap beforeDestroy");
    }
  },
  destroyed() {
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    $(".zj-app").removeClass("zj-fullscreen-map");
    console.debug("onemap destroyed");
  },
  template: "#map-template",
  controller: "UI",
  action: "OneMap"
};
</script>